module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#video",
      toString: function () {
        return this.url;
      }
    }